export function formatDateTimeInIST(input: string, type?: string) {
    const date = new Date(input);
    if (type === 'date') {
        const options: Intl.DateTimeFormatOptions = {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",  // <-- gives "Jul"
            year: "numeric",
        };

        return date.toLocaleDateString("en-IN", options);
    }
    else {
        // Convert to IST time by using options in toLocaleString
        const options: Intl.DateTimeFormatOptions = {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        };

        return date.toLocaleString("en-IN", options);
    }
}
